import React, { useContext } from 'react';
import { SvgXml } from 'react-native-svg';

import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({ icon }: { icon: string }) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  return (
    <SvgXml
      xml={icon.replace('currentColor', colors.text)}
      height={20}
      width={20}
    />
  );
}
